import React from 'react';
import {
  Input as DefaultInput,
  DateInput as DefaultDateInput,
  CurrencyInput as DefaultCurrencyInput,
  PhoneInput as DefaultPhoneInput,
  SSNInput as DefaultSSNInput,
  Select as DefaultSelectInput,
  MaskedInput as DefaultMaskedInput
} from '@ui-propulsion/react-components';
/**
 * dependency of @ui-propulsion/react-components@2
 * not declaring it in package.json because it
 * requires a Strict Equality Comparison (===)
 * class matching with the one in propulsion and
 * they could missmatch in the future
 */
import IMask from 'imask';

// This will remove props that Propulsion-UI nor Material-UI does not longer requires
// This aims to fix console errors for unrecognized DOM props.
// Feel free to remove these once you made sure they won't leak to native elements.
export const filterProps = ({
  onInputClick = undefined,
  fieldType = undefined,
  inputClasses = undefined,
  updatePageState = undefined,
  containerClasses = undefined,
  isSecondary = undefined,
  questionType = undefined,
  ...props
}) => props;

export const errorProps = ({
  showErrors = undefined,
  errors = undefined,
  validationErrors = undefined,
  helperText = undefined,
  name = undefined,
  intent = undefined,
  ...props
}) => {
  errors = errors || validationErrors;
  if (showErrors === undefined && errors) {
    showErrors = !!errors[name];
  }
  const error = showErrors
    ? Object.keys((errors && errors[name]) || {})
        .map(key => errors[name] && errors[name][key])
        .filter(x => x)
        .join('-')
    : '';

  return {
    helperText: error ? error : helperText,
    intent: error ? 'error' : intent,
    name,
    ...props
  };
};

export const helperTextProps = ({ helperText = undefined, ...props }) => {
  if (typeof helperText === 'string') {
    let helperTextArray = [];
    if (props.type === 'tel') {
      helperTextArray[0] = <li key={helperText}>{helperText}</li>;
    } else {
      helperTextArray = helperText
        .split('-')
        .filter(x => x)
        .map(text => <li key={text}>{text}</li>);
    }
    let helperTextNode;
    helperTextNode = <ul>{helperTextArray}</ul>;
    helperTextNode = helperTextArray.length > 1 ? helperTextNode : helperText;
    if (props.intent === 'error')
      helperTextNode = <div className="error-messages">{helperTextNode}</div>;
    return {
      helperText: helperTextNode,
      ...props
    };
  }
  return props;
};

// Also used in TextFields
export const transformProps = ({
  'aria-label': ariaLabel = undefined,
  'aria-labelledby': ariaLabelledBy = undefined,
  'data-qa-id': qaID = undefined,
  autocomplete = 'on',
  inputProps = {},
  ...props
}) => ({
  ...helperTextProps(errorProps(props)),
  autoComplete: autocomplete,
  fullWidth: true,
  inputProps: {
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    'data-qa-id': qaID,
    children: props.children ? props.children : null,
    ...inputProps
  }
});

export const Input = props => (
  <DefaultInput {...filterProps(transformProps(props))} />
);

export const DateInput = props => (
  <DefaultDateInput {...filterProps(transformProps(props))} />
);

export const CurrencyInput = props => (
  <DefaultCurrencyInput {...filterProps(transformProps(props))} />
);

export const PhoneInput = props => (
  <DefaultPhoneInput {...filterProps(transformProps(props))} />
);

export const SSNInput = props => (
  <DefaultSSNInput {...filterProps(transformProps(props))} />
);

export const SelectInput = props => (
  <DefaultSelectInput {...filterProps(transformProps(props))} />
);

export const MaskedInput = props => (
  <DefaultMaskedInput {...filterProps(transformProps(props))} />
);

export const MonthYearInput = props => (
  <DefaultMaskedInput
    maskOptions={{
      mask: 'm/`y',
      blocks: {
        m: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
          maxLength: 2
        },
        y: {
          mask: '00'
        }
      }
    }}
    placeholder="MM/YY"
    {...filterProps(transformProps(props))}
  />
);

require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/src/shared_modules/propulsion/components/Inputs/Inputs.scss');